app.controller('BuyCartController', ['$scope','Config','$window','helper', function($scope,Config,$window,helper){

	$scope.buyQty = 1;
	$scope.incBuyQty = function(){
		$scope.buyQty++;
	}

	$scope.decBuyQty = function(){
		if($scope.buyQty>1){
			$scope.buyQty--;
		}
	}

	$scope.changeBuyQty = function($event){
		if($event){
			qty = $event.target.value;

			if(!$scope.qtyValidation(qty)){

				//disable add to cart button
				$('.buy_controls').find('.add_to_cart_buy_button').attr('disabled','disabled');
				//hightlight input
				$('.buy_controls').find('.product_buy_quantity').addClass('error');
				//show error
				$('.buy_controls').find('.buy_qty_error').show();
				
			}else{
				//enable add to cart button
				$('.buy_controls').find('.add_to_cart_buy_button').removeAttr('disabled');
				//remove input highlight
				$('.buy_controls').find('.product_buy_quantity').removeClass('error');
				//hide error
				$('.buy_controls').find('.buy_qty_error').hide();
			}
		}
	}

	$scope.qtyValidation = function(qty){
		if(Math.floor(qty) == qty && $.isNumeric(qty) && qty>0 ){
	  		return true;
	  	}else{
	  		return false;
	  	}
	}

	$scope.buyAddHandler = function(id,slug){
		helper.showLoader();
		$window.location.href = Config.base_url+'buy?slug='+slug+'&id='+id+'&qty='+$scope.buyQty;
	}

}]);